import { Row, Col, Form, Input } from 'antd';

const SprayNozzleForm = () => {
    return (
        <Row gutter={[16, 16]}>
            {[
                { name: 'nozzle_name', label: 'Nozzle Name', required: true, message: 'This field is required', span: 12 },
                { name: 'manufacturer', label: 'Manufacturer', required: true, message: 'This field is required', span: 12 },
                { name: 'nozzle_type', label: 'Nozzle Type', required: false, span: 12 },
                { name: 'spray_angle', label: 'Spray Angle', required: false, span: 12 },
                { name: 'nozzle_material', label: 'Nozzle Material', required: false, span: 12 },
                { name: 'nozzle_size', label: 'Nozzle Size', required: false, span: 12 },
                { name: 'nozzle_colour', label: 'Nozzle Colour', required: false, span: 12 },
                { name: 'additional_information', label: 'Additional Information', required: false, span: 12 },
                { name: 'expected_life_range', label: 'Expected Life Range', required: false, span: 12 },
            ].map((field) => (
                <Col xs={{ span: 24 }} md={{ span: field.span }} key={field.name}>
                    <Form.Item
                        name={['spray', field.name]}
                        className="isoInputWrapper"
                        label={field.label}
                        rules={field.required ? [{ required: true, message: field.message }] : []}
                    >
                        <Input size="large" placeholder={field.label} />
                    </Form.Item>
                </Col>
            ))}
        </Row>
    );
};

export default SprayNozzleForm;